// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-46776cc6]{display:none}.cms-page[data-v-46776cc6]{padding:var(--spacer-sm)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
